import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { User } from '../../types/User'
import { useSelector } from 'react-redux'
import { RootState } from '../rootState'

const initialState = {
  user: undefined,
}

interface UserState {
  user: User | null | undefined
}

const slice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    set: (state: UserState, action: PayloadAction<User | null | undefined>) => {
      state.user = action.payload
    },
  },
})

export const useUser = (): User | null | undefined =>
  useSelector((state: RootState) => state.user.user)

export const USER_STORE_NAME = slice.name
export const UserActions = slice.actions
export default slice.reducer
